export default __webpack_public_path__ + "rush.mp3";